<template>
  <div id="app">
    <Index msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import Index from "./components/index.vue";

export default {
  name: "App",
  components: {
    Index,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html {
  background: #ea2723;
}

body {
  width: 540px;
  margin: 0 auto !important;
}

body,
p,
span {
  margin: 0;
}
</style>
